/* tc-noel.js — 01/11/2026 : neige en relief, compte à rebours, cartes inclinables, étincelles.
   Chargé seulement du 1er novembre au 6 janvier (snippets/tc-noel.liquid). Respecte « réduire les animations ». */
(function () {
  'use strict';
  if (window.tcNoel) return;
  var d = document, w = window;
  var mm = function (q) { return !!(w.matchMedia && w.matchMedia(q).matches); };
  var reduit = mm('(prefers-reduced-motion: reduce)');
  var souris = mm('(hover: hover) and (pointer: fine)');
  var CLE = 'tc_neige';
  function lire() { try { return w.localStorage.getItem(CLE); } catch (e) { return null; } }
  function ecrire(v) { try { w.localStorage.setItem(CLE, v); } catch (e) {} }
  d.documentElement.classList.add('tc-noel-on');

  /* ---------- Neige : 3 plans de profondeur, cristaux qui se retournent, vent qui suit la souris ---------- */
  var cv = null, ctx = null, W = 0, H = 0, flocons = [], raf = 0, tPrec = 0, vent = 0, ventCible = 0, enMarche = false;
  var rond = null, cristal = null;
  function sprites() {
    var c = d.createElement('canvas'); c.width = c.height = 32;
    var g = c.getContext('2d'), gr = g.createRadialGradient(16, 16, 0, 16, 16, 16);
    gr.addColorStop(0, 'rgba(255,255,255,1)'); gr.addColorStop(0.45, 'rgba(255,255,255,0.85)'); gr.addColorStop(1, 'rgba(255,255,255,0)');
    g.fillStyle = gr; g.beginPath(); g.arc(16, 16, 16, 0, 6.2832); g.fill(); rond = c;
    var k = d.createElement('canvas'); k.width = k.height = 64;
    var h = k.getContext('2d');
    h.translate(32, 32); h.strokeStyle = 'rgba(255,255,255,0.95)'; h.lineCap = 'round'; h.lineWidth = 3.2;
    h.shadowColor = 'rgba(255,255,255,0.8)'; h.shadowBlur = 6;
    for (var i = 0; i < 6; i++) {
      h.beginPath();
      h.moveTo(0, 0); h.lineTo(0, -26);
      h.moveTo(0, -10); h.lineTo(-7, -17); h.moveTo(0, -10); h.lineTo(7, -17);
      h.moveTo(0, -18); h.lineTo(-5, -23); h.moveTo(0, -18); h.lineTo(5, -23);
      h.stroke(); h.rotate(Math.PI / 3);
    }
    cristal = k;
  }
  function combien() { return W < 750 ? 38 : (W < 1200 ? 70 : 105); }
  function flocon(partout) {
    var z = Math.random(), c = z < 0.55 ? 0 : (z < 0.88 ? 1 : 2);
    return {
      x: Math.random() * W, y: partout ? Math.random() * H : -12 - Math.random() * 60, c: c,
      r: c === 0 ? 1 + Math.random() * 1.3 : (c === 1 ? 2.2 + Math.random() * 1.8 : 3.6 + Math.random() * 2.6),
      vy: 0.35 + c * 0.42 + Math.random() * 0.35, ph: Math.random() * 6.28, amp: 0.25 + Math.random() * 0.8,
      rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.03, cr: c > 0 && Math.random() < 0.5,
      a: c === 0 ? 0.55 : (c === 1 ? 0.8 : 0.95)
    };
  }
  function dimension() {
    var dpr = Math.min(w.devicePixelRatio || 1, 1.5);
    W = w.innerWidth; H = w.innerHeight;
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var n = combien();
    while (flocons.length < n) flocons.push(flocon(true));
    if (flocons.length > n) flocons.length = n;
  }
  function image(t) {
    raf = w.requestAnimationFrame(image);
    var dt = tPrec ? Math.min((t - tPrec) / 16.7, 3) : 1; tPrec = t;
    vent += (ventCible - vent) * 0.02;
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < flocons.length; i++) {
      var f = flocons[i];
      f.ph += 0.012 * dt;
      f.x += (Math.sin(f.ph) * f.amp * 0.6 + vent * (0.35 + f.c * 0.45)) * dt;
      f.y += f.vy * dt;
      f.rot += f.vr * dt;
      if (f.y > H + 14 || f.x < -30 || f.x > W + 30) { flocons[i] = flocon(false); continue; }
      ctx.globalAlpha = f.a;
      if (f.cr) {
        var s = f.r * 3.2;
        ctx.save(); ctx.translate(f.x, f.y); ctx.rotate(f.rot);
        ctx.scale(0.25 + 0.75 * Math.abs(Math.cos(f.ph * 1.7)), 1); /* le cristal se retourne : effet de relief */
        ctx.drawImage(cristal, -s, -s, s * 2, s * 2); ctx.restore();
      } else {
        var q = f.r * 2.2; ctx.drawImage(rond, f.x - q, f.y - q, q * 2, q * 2);
      }
    }
    ctx.globalAlpha = 1;
  }
  function demarrer() {
    if (enMarche) return;
    if (!cv) {
      cv = d.createElement('canvas'); cv.className = 'tc-neige'; cv.setAttribute('aria-hidden', 'true');
      ctx = cv.getContext('2d'); if (!ctx) { cv = null; return; }
      sprites(); d.body.appendChild(cv); dimension();
    }
    enMarche = true; cv.style.display = ''; tPrec = 0; raf = w.requestAnimationFrame(image);
  }
  function arreter() {
    enMarche = false;
    if (raf) w.cancelAnimationFrame(raf); raf = 0;
    if (cv) { ctx.clearRect(0, 0, W, H); cv.style.display = 'none'; }
  }
  var pref = lire(), neige = pref ? pref === '1' : !reduit;
  var btn = d.querySelector('[data-tc-neige-btn]');
  function maj() {
    if (btn) btn.setAttribute('aria-pressed', neige ? 'true' : 'false');
    if (neige && !d.hidden) demarrer(); else arreter();
  }
  if (btn) btn.addEventListener('click', function () { neige = !neige; ecrire(neige ? '1' : '0'); maj(); });
  d.addEventListener('visibilitychange', function () { if (d.hidden) arreter(); else if (neige) demarrer(); });
  var tRedim = 0;
  w.addEventListener('resize', function () { clearTimeout(tRedim); tRedim = setTimeout(function () { if (cv) dimension(); }, 150); });
  if (souris) w.addEventListener('pointermove', function (e) { ventCible = (e.clientX / (W || 1) - 0.5) * 1.3; }, { passive: true });
  maj();

  /* ---------- Étincelles dorées ---------- */
  var COUL = ['#c29b46', '#e9d29a', '#ffffff', '#a3262f', '#2f6b4f', '#7cc8ff'];
  function eclats(el, n) {
    if (reduit || !el || !el.getBoundingClientRect) return;
    var r = el.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    for (var i = 0; i < (n || 18); i++) {
      var s = d.createElement('span'), a = Math.random() * 6.2832, dist = 40 + Math.random() * 80;
      s.className = 'tc-eclat'; s.setAttribute('aria-hidden', 'true');
      s.style.left = cx + 'px'; s.style.top = cy + 'px';
      s.style.setProperty('--dx', (Math.cos(a) * dist).toFixed(1) + 'px');
      s.style.setProperty('--dy', (Math.sin(a) * dist - 25).toFixed(1) + 'px');
      s.style.setProperty('--h', COUL[i % COUL.length]);
      d.body.appendChild(s);
      setTimeout(function (x) { return function () { x.remove(); }; }(s), 1100);
    }
  }
  /* à l'ajout au panier (fiche produit et ajout rapide) */
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || (f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    eclats(f.querySelector('[type="submit"]') || f, 20);
  }, true);

  /* ---------- Vitrine : cadeau 3D qui s'ouvre, compte à rebours, traînée d'étoiles ---------- */
  var comptes = d.querySelectorAll('[data-tc-compte]');
  if (comptes.length) {
    var mtn = new Date(), j = Math.ceil((new Date(mtn.getFullYear(), 11, 25) - mtn) / 864e5);
    for (var k = 0; k < comptes.length; k++) {
      if (j <= 0) { comptes[k].textContent = '🎄 Joyeux Noël !'; continue; }
      var b = comptes[k].querySelector('[data-j]'), u = comptes[k].querySelector('[data-s]');
      if (b) b.textContent = j;
      if (u) u.textContent = j > 1 ? 'jours' : 'jour';
    }
  }

  if (souris && !reduit) {
    var heros = d.querySelectorAll('.tc-noel-hero');
    for (var m = 0; m < heros.length; m++) (function (hero) {
      var dernier = 0;
      hero.addEventListener('pointermove', function (e) {
        var t = Date.now(); if (t - dernier < 45) return; dernier = t;
        var s = d.createElement('span'); s.className = 'tc-trainee'; s.setAttribute('aria-hidden', 'true');
        s.style.left = e.clientX + 'px'; s.style.top = e.clientY + 'px';
        d.body.appendChild(s); setTimeout(function () { s.remove(); }, 900);
      }, { passive: true });
    })(heros[m]);

    /* ---------- Cartes produit inclinables en relief ---------- */
    var cour = null;
    var lacher = function (c) { c.classList.remove('tc-incline'); };
    d.addEventListener('pointermove', function (e) {
      var c = e.target && e.target.closest ? e.target.closest('.card-wrapper') : null;
      if (c !== cour) { if (cour) lacher(cour); cour = c; }
      if (!c) return;
      var r = c.getBoundingClientRect(), px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
      c.style.setProperty('--tc-ry', (px * 9).toFixed(2) + 'deg');
      c.style.setProperty('--tc-rx', (-py * 9).toFixed(2) + 'deg');
      c.style.setProperty('--tc-gx', ((px + 0.5) * 100).toFixed(1) + '%');
      c.style.setProperty('--tc-gy', ((py + 0.5) * 100).toFixed(1) + '%');
      if (!c.classList.contains('tc-incline')) c.classList.add('tc-incline');
    }, { passive: true });
    d.documentElement.addEventListener('pointerleave', function () { if (cour) { lacher(cour); cour = null; } });
  }

  w.tcNoel = { eclats: eclats, neige: function (on) { neige = !!on; maj(); } };
})();
